<div
  class="layout-wrapper"
  [class.sidebar-open]="showSidebar"
  [class.sidebar-collapsed]="isSidebarCollapsed"
>
  @if (showSidebar) {
    <app-sidebar-wrapper
      [collapsed]="isSidebarCollapsed"
      (collapsedChange)="onSidebarCollapsedChange($event)"
    />
  }

  <div
    class="main-wrapper"
    [class.sidebar-open]="showSidebar"
    [class.sidebar-collapsed]="isSidebarCollapsed"
  >
    @if (showHeader) {
      <app-topbar-wrapper
        [userName]="userName()"
        [isDarkMode]="isDarkMode()"
        [logoUrl]="logoUrl()"
        [itemsProfileMenu]="itemsProfileMenu()"
        [showSearch]="showSearch()"
        [showNotifications]="showNotifications()"
        [showRefresh]="showRefresh()"
        [showSystemDate]="showSystemDate()"
        (darkModeToggle)="darkmodeChange()"
        [showProducts]="showProducts()"
        (logout)="logout()"
      />
    }

    @if (showBreadcrumb) {
      <app-breadcrumb-wrapper />
    }

    <br />
    <main class="content">
      <router-outlet></router-outlet>
    </main>
    <app-footer-wrapper [variant]="footerVariant"></app-footer-wrapper>
  </div>
</div>
